import { EyeOff, Link2 } from 'lucide-react'
import { SeoConfigTable } from './SeoConfigTable'
import { SEO_STR as S } from './seoApi'

/**
 * A12.04 — Canonical URL qoidalari. Path → canonical URL. CRUD
 * `/admin/seo/canonical` (fail-soft).
 */
export function CanonicalScreen() {
  return (
    <SeoConfigTable
      screenId="A12.04"
      title={S.canonical}
      addLabel={S.addCanonical}
      path="/admin/seo/canonical"
      listKey="entries"
      searchKeys={['path', 'canonical']}
      icon={<Link2 size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'path', placeholder: '/page?utm=...', mono: true },
        { name: 'canonical', placeholder: 'https://mygram.my/page', mono: true },
      ]}
      columns={[
        { key: 'path', header: S.path, type: 'text' },
        { key: 'canonical', header: S.canonicalUrl, type: 'text' },
      ]}
    />
  )
}

/**
 * A12.08 — `noindex` ro'yxati. Indekslashdan chiqariladigan path-shablonlar.
 * CRUD `/admin/seo/noindex` (fail-soft).
 */
export function NoindexScreen() {
  return (
    <SeoConfigTable
      screenId="A12.08"
      title={S.noindexList}
      addLabel={S.addNoindex}
      path="/admin/seo/noindex"
      listKey="entries"
      searchKeys={['pattern', 'reason']}
      icon={<EyeOff size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'pattern', placeholder: '/admin/*', mono: true },
        { name: 'reason', placeholder: S.reason },
      ]}
      columns={[
        { key: 'pattern', header: S.pattern, type: 'text' },
        { key: 'reason', header: S.reason, type: 'text' },
      ]}
    />
  )
}
